import React, { useState, useEffect } from 'react';
import { getDoc } from '../../services';
import { scoreColor } from '../../utils';
import CveVectors from './CveVectors';
import Loading from '../DocList/Loading';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getCveFields } from '../../utils';
import './CveDocument.scss';
library.add(fal);

const CveDocument = ({ cve, profile, hideId = false, cveFields, onlyKve }) => {
  const [docBody, setDocBody] = useState();

  const renderCveFields = (cve) => {
    const showFields = getCveFields();
    return cveFields.map((field) => {
      if (field.label && showFields.includes(field.fieldName)) {
        return (
          <span className='ctx-field-group'>
            <span className='cve-label'>{field.label}: </span>
            <span className='cve-value'> {cve[field.fieldName]}</span>
          </span>
        );
      }
    });
  };

  useEffect(() => {
    if (cve && cve.id && profile) {
      getDoc(cve.id, cve.repositoryId, profile, 'PlainTextView').then((res) => {
        setDocBody(res.response);
      });
    }
  }, [cve, profile]);

  return (
    <div className='CveDocument'>
      {/* <h4>{cve.title}</h4> */}
      <div className='cve-meta'>
        {!hideId && (
          <span className='cve-id ctx-field-group'>
            <span className='cve-label'>ID:</span>
            <span className='cve-value'>{cve.id}</span>
          </span>
        )}
        <span className='ctx-field-group'>
          <span className='cve-value'>{cve.title}</span>
        </span>
        {cve.cvssBaseScore ? (
          <span className='ctx-field-group cve-base-score'>
            <span className='cve-label'>Base Score: </span>
            <span className='cve-value'>
              <span
                className={`severity-coloring severity-coloring--${scoreColor(
                  cve.cvssBaseScore,
                  cve.cvssVersion
                )}`}
              >
                {cve.cvssBaseScore}
              </span>
            </span>
          </span>
        ) : null}
        {cve.cvssVector ? (
          <span className='ctx-field-group cve-base-score'>
            <span className='cve-label'>Vector: </span>
            <span className='cve-value'>
              <CveVectors vectors={cve.cvssVector} />
            </span>
          </span>
        ) : null}
        <div className='ctx-field-group cve-publish-date'>
          <span className='cve-label'>Published on </span>
          <span className='cve-value'>{cve.publishDate}</span>
        </div>
        <div className='ctx-field-group cve-references'>
          <span className='cve-label'>References:</span>
          {cve.references && (
            <ol key={`ref-${cve.id}`}>
              {Object.entries(cve.references).map(([k, v]) => (
                <li className='cve-source' key={`ref-${k}`}>
                  <span className='cve-value'>
                    <a href={v.referenceUrl} target='_blank' rel='noreferrer'>
                      {v.referenceSource}
                      <FontAwesomeIcon
                        icon={['fal', 'external-link-alt']}
                        style={{
                          verticalAlign: '-1px',
                          marginLeft: '8px',
                          fontSize: '.9em',
                        }}
                      />
                    </a>
                  </span>
                  {v.referenceDesc &&
                    v.referenceDesc.length &&
                    v.referenceDesc.substring(0, 4) !== 'http' && (
                      <div className='cve-source-desc'>
                        <span className='cve-label'>Description: </span>
                        <span className='cve-value'>{v.referenceDesc}</span>
                      </div>
                    )}
                </li>
              ))}
            </ol>
          )}
        </div>

        {onlyKve && renderCveFields(cve)}
      </div>
      <div className='ctx-document-body'>
        {docBody ? (
          <div
            className='ctx-readmore-contents resource-content'
            dangerouslySetInnerHTML={{ __html: docBody }}
          />
        ) : (
          <>
            {profile ? (
              <div style={{ textAlign: 'center' }}>
                <Loading />
              </div>
            ) : null}
          </>
        )}
      </div>
      <a
        className='ctx-button-link'
        href={cve.url}
        target='_blank'
        rel='noreferrer'
      >
        View Full CVE
        <FontAwesomeIcon
          icon={['fal', 'external-link-alt']}
          style={{ verticalAlign: '-1px', marginLeft: '8px' }}
        />
      </a>
    </div>
  );
};
export default CveDocument;
